import { render, staticRenderFns } from "./GraduatesSearchSkeleton.vue?vue&type=template&id=8bd4c47e&"
import script from "./GraduatesSearchSkeleton.vue?vue&type=script&lang=js&"
export * from "./GraduatesSearchSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports